import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function HeroSection() {
  return <section className="relative bg-brand-darker text-white overflow-hidden pt-24 pb-32 px-6 lg:px-8" data-id="element-56">
      {/* Abstract Background Elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[1000px] h-[500px] opacity-20 pointer-events-none" data-id="element-57">
        <div className="absolute inset-0 bg-gradient-to-b from-brand-accent/20 to-transparent rounded-full blur-3xl" data-id="element-58"></div>
      </div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-59">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7
      }} className="mb-10" data-id="element-60">
          <img src="https://cdn.magicpatterns.com/uploads/nok7wXRxCZ1wQoMoRCHHB1/portada_4.png" alt="Guía de Micro-Emprendimiento - Vista previa en móvil" className="mx-auto w-56 md:w-64 lg:w-72 drop-shadow-[0_20px_40px_rgba(245,158,11,0.15)]" data-id="element-61" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} data-id="element-62">
          <span className="inline-block py-1 px-3 rounded-full bg-brand-accent/10 text-brand-accent text-sm font-bold tracking-wider uppercase mb-6" data-id="element-63">
            Guía de Micro-Emprendimientos
          </span>
          <h1 className="font-heading text-5xl md:text-6xl lg:text-7xl font-extrabold tracking-tight mb-6 leading-tight" data-id="element-64">
            Lanza Tu Micro-Emprendimiento Digital en{' '}
            <span className="text-brand-accent" data-id="element-65">7 Días</span>
          </h1>
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-xl md:text-2xl text-slate-300 font-medium mb-8 max-w-3xl mx-auto leading-relaxed" data-id="element-66">
          Convierte tus habilidades en ingresos reales, sin experiencia previa
        </motion.p>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.5
      }} className="text-lg text-slate-400 mb-12 max-w-3xl mx-auto leading-relaxed" data-id="element-67">
          No necesitas una gran inversión ni un título para empezar tu propio
          negocio digital. En esta guía descubrirás cómo hombres y mujeres, sin
          empleo estable o con ingresos variables, lograron lanzar su primer
          micro-emprendimiento en cuestión de días. Y tú puedes ser el
          siguiente.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-68">
          <button onClick={() => document.getElementById('offer')?.scrollIntoView({
          behavior: 'smooth'
        })} className="w-full sm:w-auto px-8 py-4 bg-brand-accent hover:bg-brand-accentHover text-brand-darker font-bold rounded-xl text-lg transition-all duration-300 transform hover:scale-105 hover:shadow-[0_0_20px_rgba(245,158,11,0.4)] flex items-center justify-center gap-2 group" data-id="element-69">
            Obtén acceso inmediato
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-70" />
          </button>
          <p className="text-sm text-slate-500 sm:hidden mt-2" data-id="element-71">
            Haz clic aquí para comenzar hoy mismo
          </p>
        </motion.div>
      </div>
    </section>;
}